<script>
import {alteraDataPagamento} from '../../../../../domain/pre-retirada/services'
import PopupViewerAlert from '../../../../_default/components/popup-viewer/PopupViewerAlert'

export default {
  name: 'BtnAlteraDataPagamentoPreretirada',
  components: {PopupViewerAlert},
  props: {
    preRetiradaId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      dataPagamento: null,
      show: false
    }
  },
  methods: {
    setDataPagamento () {
      const dataPagamentoFormatada = this.dataPagamento.split('-').reverse().join('/')
      if (!confirm(`ATENÇÃO: Confirmar alteração da data de pagamento para "${dataPagamentoFormatada}"?`)) {
        this.show = false
        this.dataPagamento = null
        return
      }
      this.$loaderOverlay.open().message('Alterando a data de pagamento...')
      alteraDataPagamento(this.preRetiradaId, this.dataPagamento)
        .then(response => {
          this.show = false
          this.dataPagamento = null
          this.$emit('dataAlterada', response.data.dataPagamento)
        })
        .catch(error => {
          alert('Houve um erro ao alterar a data de pagamento')
          console.log(error.data)
        })
      .finally(() => {
        this.$loaderOverlay.hide()
      })
    },
    toggleShow () {
      this.show = !this.show
    },
    cancelar () {
      this.dataPagamento = null
      this.show = false
    }
  }
}
</script>

<template>
<div>
  <div class="m-t-sm m-b-sm">
    <a class="btn btn-default font-bold btn-dark" @click="toggleShow">{{show ? 'Cancelar' : 'Alterar data de pagamento'}}</a>
  </div>
  <popup-viewer-alert v-if="show" title="Alteração manual de data de pagamento">
    <div class="form-group m-t-sm">
      <input v-model="dataPagamento" class="form-control" type="date" />
    </div>
    <div style="display: flex; justify-content: end; align-items: center">
      <button class="btn btn-sm btn-default m-l" @click="cancelar">Cancelar</button>
      <button class="btn btn-sm btn-info m-l" @click="setDataPagamento" :disabled="!dataPagamento">Confirmar</button>
    </div>
  </popup-viewer-alert>
</div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// BtnAlteraDataPagamentoPreretirada.vue?62e0ab67